<template>
  <button
    class="zt-button relative inline-flex select-none items-center justify-center overflow-hidden rounded border-none px-4 align-middle"
    :class="[
      {
        'text-white': !outlined,
        'rounded-zt-lg': rounded,
        'zt-button-fab': fab,
        'zt-button-contained': !computedIsText,
      },
      computedIsOutlined,
      computedIsText,
      computedIsDisabled,
      computedIsBgColor,
      computedIsSize,
      gtmClass,
    ]"
    :id="componentId"
    ref="button"
    v-bind="$attrs"
    @click="clickButtonEvt"
    @mousedown="mouseDownEvt"
    name="button"
  >
    <span
      v-if="icon && !iconAfter && !loader"
      class="pointer-events-none inline-flex items-center justify-center tracking-normal"
    >
      <zt-icon class="pointer-events-none" :name="icon" />
    </span>
    <span
      v-if="loader && !iconAfter"
      class="pointer-events-none inline-flex items-center justify-center tracking-normal"
    >
      <zt-icon name="spinner" class="zt-button-loader" />
    </span>
    <span
      v-if="!fab"
      class="zt-button-text pointer-events-none mx-2 inline-flex items-center"
    >
      <p v-if="loader && loaderTxt" class="pointer-events-none">
        {{ loaderTxt }}
      </p>
      <slot v-else />
    </span>
    <span
      v-if="icon && iconAfter && !loader"
      class="pointer-events-none inline-flex items-center justify-center tracking-normal"
    >
      <zt-icon :name="icon" class="pointer-events-none" />
    </span>
    <span
      v-if="loader && iconAfter"
      class="pointer-events-none inline-flex items-center justify-center tracking-normal"
    >
      <zt-icon name="spinner" class="zt-button-loader" />
    </span>
    <span v-if="isRipple" class="zt-button-ripple pointer-events-none" />
  </button>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'ztButton',
  props: {
    icon: { type: String, default: '' },
    iconAfter: { type: Boolean, default: false },
    type: { type: String, default: '' },
    color: { type: String, default: 'primary' },
    size: { type: String, default: 'default' },
    rounded: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    text: { type: Boolean, default: false },
    fab: { type: Boolean, default: false },
    loader: { type: Boolean, default: false },
    loaderTxt: { type: String, default: '' },
    gtmClass: { type: String, default: '' },
  },
  data() {
    return {
      componentId: '',
      isRipple: false,
    }
  },
  mounted() {
    this.componentId = this._uid
  },
  computed: {
    computedIsOutlined() {
      return this.outlined ? 'zt-button-outline-' + this.color : null
    },
    computedIsText() {
      const colorLevel = this.color === 'primary' || this.color === 'secondary' ? '-200' : ''
      return this.text
        ? 'text-zt-' + this.color + colorLevel + ' zt-button-bg-white hover:shadow-none shadow-none'
        : null
    },
    computedIsDisabled() {
      let disabledClass = ''
      if (this.$attrs.disabled) disabledClass = 'zt-button-disabled'
      if (this.$attrs.disabled && this.outlined) disabledClass = 'zt-button-disabled-outline'
      if (this.$attrs.disabled && this.text) disabledClass = 'zt-button-disabled-text'
      return disabledClass
    },
    computedIsBgColor() {
      const colorLevel = this.color === 'primary' || this.color === 'secondary' ? '-200' : ''
      return 'bg-zt-' + this.color + colorLevel
    },
    computedIsSize() {
      return 'zt-button-size-' + this.size
    },
  },
  methods: {
    clickButtonEvt(event) {
      if (!this.loader) {
        this.$emit('click', event)
      }
    },
    mouseDownEvt(event) {
      this.$emit('mousedown', event)
      this.isRipple = true
      setTimeout(() => { this.isRipple = false }, 300)
    },
  },
}
</script>

<style scoped lang="css" src="../../../../styles/components/ztButton.css" />
